import _ from 'lodash';

const mapRaceResults = races => {
    return races.map(x => {
        return {
            ...x,
            date: x.date.toLocaleDateString(),
            createdAt: x.createdAt.toLocaleDateString()
        };
    })
};

const mapRaceCalenderItem = race => {
    return {
        ...race,
        startDate: race.startDate.toLocaleDateString(),
        endDate: race.endDate.toLocaleDateString(),
        createdAt: race.createdAt.toLocaleDateString(),
        updatedAt: race.updatedAt.toLocaleDateString(),
        RacePromoter: mapPromoter(race.RacePromoter)
    };
}

const mapPromoter = item => {
    return {
        ...item,
        RaceEvents: (item?.RaceEvents ?? []).map(x => mapRaceEvent(x)),
        RaceCalendarItem: (item?.RaceCalendarItem ?? []).map(x => mapRaceCalenderItem(x))
    };
};

const mapRaceEvent = item => {
    return {
        ...item,
        date: item.date.toLocaleDateString(),
        createdAt: item.createdAt.toLocaleDateString(),
    };
}

const mapRaceCalendarItems = races => {
    return races.map(race => mapRaceCalenderItem(race));
};

const mapRiderClaims = claims => {
    return claims.map(claim => mapRiderClaimItem(claim));
}

const mapRiderClaimItem = claim => {
    return {
        ...claim,
        createdAt: claim.createdAt.toLocaleDateString(),
        Products: (claim.Products ?? [])?.map(x => mapProduct(x)),
        Trainers: (claim.Trainers ?? [])?.map(x => mapTrainer(x)),
        TrainingFacilities: (claim.TrainingFacilities ?? []).map(x => mapTrainingFacility(x)),
        SponsorImages: (claim.SponsorImages ?? [])?.map(x => mapSponsorImage(x)),
    }
}

const mapSponsorImage = image => {
    return {
        ...image,
        createdAt: image.createdAt.toLocaleDateString(),
    }
}

const mapTrainers = trainers => {
    return trainers.map(x => mapTrainer(x));
}

const mapTrainer = trainer => {
    if (!trainer) {
        return null;
    }
    return {
        ...trainer,
        createdAt: trainer.createdAt.toLocaleDateString(),
        Riders: (trainer.Riders ?? []).map(x => mapRiderClaimItem(x))
    }
}

const mapTrainingFacility = facility => {
    return {
        ...facility,
        createdAt: facility.createdAt.toLocaleDateString(),
        Riders: (facility.Riders ?? []).map(x => mapRiderClaimItem(x))
    };
}

const mapTrainingFacilities = facilities => {
    return facilities.map(x => mapTrainingFacility(x));
}

const mapProductCategories = categories => {
    return categories.map(x => mapProductCategory(x));
}

const mapProductCategory = categeory => {
    if (!categeory) {
        return null;
    }
    return {
        ...categeory,
        createdAt: categeory?.createdAt.toLocaleDateString()
    };
}

const mapProducts = products => {
    return products.map(x => mapProduct(x));
}

const mapProduct = product => {
    return {
        ...product,
        createdAt: product.createdAt.toLocaleDateString(),
        Riders: (product.Riders ?? []).map(x => mapRiderClaimItem(x)),
        Category: mapProductCategory(product.Category),
        Reviews: mapProductReviews(product.Reviews || [])
    };
}

const mapProductReviews = reviews => {
    return reviews.map(review => mapProductReview(review));
}

const mapProductReview = review => {
    return {
        ...review,
        createdAt: review.createdAt.toLocaleDateString(),
        User: mapUser(review.User)
    };
}

const mapUser = user => {
    return {
        ...user,
        createdAt: user.createdAt.toLocaleDateString(),
        updatedAt: user.updatedAt.toLocaleDateString(),
        RiderClaims: mapRiderClaims(user.RiderClaims)
    };
}

const mapVehicles = vehicles => {
    return vehicles.map(vehicle => mapVehicle(vehicle));
}

const mapVehicle = vehicle => {
    return {
        ...vehicle,
        createdAt: vehicle.createdAt.toLocaleDateString(),
        Notes: _.orderBy(vehicle.Notes, ["createdAt"], ["desc"]).map(note => mapVehicleNote(note))
    };
}

const mapVehicleNote = note => {
    return {
        ...note,
        createdAt: note.createdAt.toLocaleDateString()
    };
}

const mapAreaQualifiers = qualifiers => {
    return qualifiers.map(qualifier => mapAreaQualifier(qualifier));
}

const mapAreaQualifier = item => {
    if (!item) {
        return {};
    }
    return {
        ...item,
        createdAt: item.createdAt?.toLocaleDateString(),
        date: item.date?.toLocaleDateString()
    };
}

const mapRegionalQualifier = item => {
    if (!item) {
        return {};
    }
    return {
        ...item,
        createdAt: item.createdAt?.toLocaleDateString(),
        date: item.date?.toLocaleDateString()
    };
}

const mapAreaQualifierClass = item => {
    const result = {
        ...item,
        createdAt: item.createdAt.toLocaleDateString()
    };

    if (item.AreaQualifier) {
        result.AreaQualifier = mapAreaQualifier(item.AreaQualifier)
    }

    return result;
}

const mapRegionalQualifierClass = item => {
    const result = {
        ...item,
        createdAt: item.createdAt.toLocaleDateString()
    };

    if (item.RegionalQualifier) {
        result.RegionalQualifier = mapRegionalQualifier(item.RegionalQualifier)
    }

    return result;
}

const mapAreaQualifierResults = results => {
    return results.map(result => mapAreaQualifierResult(result));
}

const mapRegionalQualifierResults = results => {
    return results.map(result => mapRegionalQualifierResult(result));
}

const mapAreaQualifierResult = item => {
    const result = {
        ...item,
        createdAt: item.createdAt.toLocaleDateString()
    };

    if (item.AreaQualifierClass) {
        result.AreaQualifierClass = mapAreaQualifierClass(item.AreaQualifierClass);
    }

    return result;
}

const mapRegionalQualifierResult = item => {
    const result = {
        ...item,
        createdAt: item.createdAt.toLocaleDateString(),
        powerRanking: Number(item.powerRanking)
    };

    if (item.RegionalQualifierClass) {
        result.RegionalQualifierClass = mapRegionalQualifierClass(item.RegionalQualifierClass);
    }

    return result;
}

const mapLorettaAreaQualifierRaces = races => {
    return races.map(result => mapLorettaAreaQualifierRace(result));
}

const mapLorettaAreaQualifierRace = race => {
    return {
        ...race,
        date: race.date.toLocaleDateString(),
        createdAt: race.createdAt.toLocaleDateString(),
        calendarDate: race.date.toISOString().split('T')[0],
        calendarSort: Math.floor(race.date.getTime() / 1000),
        Track: mapTrack(race.Track)
    };
}

const mapTracks = tracks => {
    return tracks.map(track => mapTrack(track));
}

const mapTrack = track => {
    return {
        ...track,
        createdAt: track.createdAt.toLocaleDateString(),
        AreaQualifiers: (track.AreaQualifiers ?? []).map(x => mapAreaQualifier(x))
    };
}

export const mapTrainerSessions = sessions => {
    return sessions.map(x => mapTrainingSession(x));
}

export const mapTrainingSession = session => {
    return {
        ...session,
        createdAt: session.createdAt.toLocaleDateString(),
        date: session.date.toLocaleDateString(),
        Entries: (session.Entries || []).map(x => mapTrainingSessionEntry(x)),
        Trainer: (!!session.Trainer ? mapTrainer(session.Trainer) : null)
    }
}

export const mapTrainingSessionEntry = entry => {
    return {
        ...entry,
        createdAt: entry.createdAt.toLocaleDateString(),
    }
}

const EntityMappingService = {
    mapRaceResults,
    mapRaceCalendarItems,
    mapRaceCalenderItem,
    mapRiderClaims,
    mapRiderClaimItem,
    mapTrainers,
    mapTrainer,
    mapTrainingFacility,
    mapTrainingFacilities,
    mapProductCategory,
    mapProductCategories,
    mapProducts,
    mapProduct,
    mapVehicles,
    mapVehicle,
    mapAreaQualifiers,
    mapAreaQualifier,
    mapAreaQualifierResults,
    mapRegionalQualifierResults,
    mapLorettaAreaQualifierRaces,
    mapTracks,
    mapTrack,
    mapTrainerSessions,
    mapTrainingSession
};

export default EntityMappingService;
